import { styled, Box } from '@mui/material';
export const GroupingElement = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'in_panel' && prop !== 'grouping_mode',
})(({ in_panel, grouping_mode }) => ({
    opacity: in_panel ? 1 : 0.3,
    transition: 'all 0.2s ease-in-out',
    pointerEvents: grouping_mode ? 'none' : 'all',
    height: '100%',
}));
